// HS Form Context
import * as React from 'react';
import { GenericContextHandlers } from './GenericContext';
import { Sanitized } from '../@types/sanitized';
import { BillingContext } from './BillingContext';

export type PromoContextHandlers = GenericContextHandlers &
    BillingContext & {
        handleChange: (
            nameValuePairs: Array<Sanitized.CartItemNameValuePair>,
            updateCartOnServer?: boolean | null,
            chosenSpendRatio?: Sanitized.spendRatioObject | null
        ) => Promise<any>;
        contextType: 'promo';
        cartItem: Sanitized.PromoCartItem;
        updateFullCart: (newCartItem: Sanitized.PromoCartItem) => void;
        setViewUploadOwnAd: (isOwnAdShowing: boolean) => void;
        viewUploadOwnAd: boolean;
        activePromotions: Sanitized.availablePromotion[];
        getBoostAudienceGeoSource: () => Array<Sanitized.BoostSourceGeo>;
        frontEndStripeDataFields: Sanitized.frontEndStripeDataFieldsObject;
        promoConfirmationPageData: Sanitized.promoConfirmationPageDataObject;
        setPromoConfirmationPageData: (data: Sanitized.promoConfirmationPageDataObject) => void;
        message: string;
        setMessage: (message: string) => void;
        requiresPrepayment: boolean;
        isOutsideUSA: () => boolean;
    };

const PromoContext = React.createContext<Partial<PromoContextHandlers>>({});

export const usePromoContext = (): Partial<PromoContextHandlers> => React.useContext(PromoContext);

export default PromoContext;
